module.exports = __webpack_public_path__ + "img/mtbd_3.a98ffe47.png";